module.exports = __webpack_public_path__ + "img/cargo-wagon-1.8951c6d1.png";